<template>
    <activation-brief-personal-info-provider
        v-slot="{
            brief,
            step,
            goNextStep,
            goPreviousStep,
            briefFields,
            isLoading,
            isCompletingBrief,
            errors,
            errorMessage,

        }"
        style="height: 100%">
        <activation-brief-personal-info-view
            :brief="brief"
            :step="step"
            :is-loading="isLoading"
            :brief-fields="briefFields"
            :is-completing-brief="isCompletingBrief"
            :errors="errors"
            :error-message="errorMessage"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
        />
    </activation-brief-personal-info-provider>
</template>

<script>
    import ActivationBriefPersonalInfoView from '../data-views/activation-briefs/ActivationBriefPersonalInfoView';
    import ActivationBriefPersonalInfoProvider from '../providers/activation-brief-steps/ActivationBriefPersonalInfoProvider';

    export default {
        name:       'ActivationBriefPersonalInfoRouterView',
        components: {
            ActivationBriefPersonalInfoProvider,
            ActivationBriefPersonalInfoView,
        },
    };
</script>
